import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import TextRenderer from '../../../TextRenderer';
import { ShortStatusViewer, LongStatusViewer, } from '../../../DaEditorWrapper/Viewer/Status';
import { getIsShortStatus, getStatusBackgroundProps } from '../../_helpers';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import LoadingIndicator from '../../../LoadingIndicator';
import ConditionalWrapper from '../../../ConditionalWrapper';
import Background from '../../../Background';
import s from './Status.scss';
export var StatusFullView = function (_a) {
    var _b = _a.deviation, status = _b.status, textContent = _b.textContent, deviation = _a.deviation, width = _a.width;
    var backgroundProps = getStatusBackgroundProps(deviation);
    if (!status) {
        return null;
    }
    if (!textContent || !(textContent.excerpt || textContent.html.markup)) {
        return null;
    }
    // Display logic
    // Legacy gets its own styles
    // If any media inserted it cant be short
    var isLegacy = textContent.html.type === 'writer';
    var isShortStatus = getIsShortStatus(deviation);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return (React.createElement("div", { className: classnames(s['root'], isLegacy && s['legacy'], isShortStatus && s['short-status']) },
        isExtendedLoaded && (React.createElement(ConditionalWrapper, { condition: isShortStatus, wrap: function (child) { return (React.createElement(Background, __assign({ className: classnames(s['background-wrapper'], isShortStatus && s['short-status']), width: width, variant: "status" }, backgroundProps), child)); } },
            React.createElement(TextRenderer, { textContent: textContent, className: s['text'], reactViewer: isShortStatus ? ShortStatusViewer : LongStatusViewer, legacyTheme: isShortStatus ? 'short-status' : 'status', viewerKey: deviation.deviationId }))),
        !isExtendedLoaded && React.createElement(LoadingIndicator, { view: "llama", coverMode: true })));
};
StatusFullView.displayName = 'StatusFullView';
export default StatusFullView;
//# sourceMappingURL=Status.js.map